import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import React from 'react'
import { LoadingMaskRectangle } from '../../legacy-design-system/loading-masks'
import { ApplicationRouteBreakdown } from './api/get-application-modules'
import { routeCoverageColumnWidth } from './application-modules-grid'

export const routeCoverageCellTestId = 'route-coverage-cell-test-id'

export function routeCoverageColumnCellRenderer({
  isLoading,
  routes
}: {
  isLoading: boolean
  routes: ApplicationRouteBreakdown
}) {
  return isLoading ? (
    <LoadingMaskRectangle height={15} width={routeCoverageColumnWidth - 25} />
  ) : (
    <div data-testid={routeCoverageCellTestId}>
      <span>{routes.exercised}</span> /{' '}
      <span
        className={css`
          color: ${theme.color.neutral70};
        `}
      >
        {routes.discovered}
      </span>
    </div>
  )
}
